import { AttachedContent } from '../../trait/attachedcontent/AttachedContent';
export class AttachedAudio extends AttachedContent {
    type = 'audio';
}
